import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CurrentUser } from '@app/shared/auth';
import { LinkComponent } from '@app/shared/ui/link';
import { linkData } from './link-data';
import { homeRoutePermissions } from './permissions';

@Component({
  selector: 'app-home-page',
  imports: [MatButtonModule, LinkComponent],
  templateUrl: './home.component.html',
  host: {
    class: 'block h-full w-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent {
  readonly #currentUser = inject(CurrentUser);
  readonly currentUser = computed(() => this.#currentUser.get());
  readonly linkData = linkData;
  readonly canShowLinks = computed(() => {
    const user = this.#currentUser.get();
    return user != null && homeRoutePermissions.showLinkCollection(user);
  });
}
